'use strict'

export default  function () {

  this.reset = function () {
    window.scrollTo(500, 0);
  }
}
